<script setup lang="ts">
defineProps<{
    sidebarCollapsed: boolean
}>()
</script>

<template>
    <div class="min-h-screen bg-gray-50">
        <slot name="sidebar" />
        <slot name="topbar" />
        <main
            :class="[
                'pt-th transition-[padding] duration-normal',
                // Mobile (< lg): no left padding — sidebar is an off-canvas overlay drawer.
                // Desktop (lg+): leave space for the sidebar; collapsed vs expanded width.
                sidebarCollapsed ? 'lg:pl-sw-c' : 'lg:pl-sw'
            ]"
        >
            <div class="p-3 md:p-6">
                <slot />
            </div>
        </main>
    </div>
</template>
